import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import VacationType from './filters/VacationType';
import Dates from './filters/Dates/Dates';
import Budget from './filters/Budget';
import Guests from './filters/Guests';
import DepartureDropdown from './filters/DepartureDropdown';
import DepartureMultiSelect from './filters/Departure/DepartureMultiSelect';
import MainFilterPreloader from './MainFilterPreloader';
import { useDispatch, useSelector } from 'react-redux';
import DestinationFilter from './filters/Destination/DestinationFilter';
import useHideFilter from '../../hooks/useHideFilter';
import { selectFilterData } from './selectors';
import { isMobile } from '../../utilities/helpers';
import { selectGlobalLoading } from '../../appSlice';
import { t } from '../../utilities/translator';
import { startOverWizard } from '../wizard-v2/onboardingSlice';

function MainFilter({ handleShowFade, sticky, setSticky }) {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const { heroSectionLoading } = useSelector(selectGlobalLoading);
  const visible = useHideFilter();
  const cls = visible ? 'visible-filters' : 'hidden-filters';
  const {
    searchEngine: { fromwhere: departures },
  } = useSelector(selectFilterData);

  const handleStartOverClick = () => {
    window.scrollTo(0, 0);
    dispatch(startOverWizard());
  }

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const refPosition = ref.current.offsetTop;
        setSticky(isMobile() ? window.scrollY > refPosition + 250 : window.scrollY - 70 > refPosition);
      }
    };

    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [setSticky]);

  const filterComponent = (
    <div
      className={classNames(`main-filter__wrap ${cls}`, {
        'main-filter__wrap--sticky': sticky,
      })}
    >
      <div
        className={classNames('c-container main-filter-container', {
          pending: heroSectionLoading,
        })}
      >
        <div className={classNames('c-row flex-col', { 'gap-5': !sticky })}>
          {heroSectionLoading ? (
            <MainFilterPreloader />
          ) : (
            <>
              <div className="flex gap-3 col-lg-12">
                {(!sticky && window.innerWidth >= 768) && (
                  <button className="btn-start-wizard-desktop" onClick={handleStartOverClick}>
                    <i className="ri-magic-line" />
                    {t('customize.startWizard')}
                  </button>
                )}
                {
                  (departures.length > 1)
                    ? <DepartureMultiSelect />
                    : <DepartureDropdown />
                }
              </div>
              <div className="col-lg-12">
                <div className="main-filter">
                  <VacationType />
                  <DestinationFilter />
                  <Dates handleShowFade={handleShowFade} />
                  <Guests />
                  <Budget />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );

  const portal = document.getElementById('sticky-filters-portal');

  return (
    <div className="main-filter__outer-wrap" ref={ref} style={{ height: window.innerWidth >= 768 && sticky ? `159px` : `auto` }}>
      {sticky ? createPortal(filterComponent, portal) : filterComponent}
    </div>
  );
}

export default MainFilter;
